import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.COPAY_PRICE_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.COPAY_PRICE_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.COPAY_PRICE_FAILURE:
      return {
        data: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.COPAY_PRICE_RESET:
      return {
        isProgress: false,
        data: {},
        error: "",
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: {},
      };
    default:
      return state;
  }
}
